import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const finish = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const res = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) {
          const detail = res.status === 403 ? "unauthorized" : "failed";
          throw new Error(detail);
        }
        const user = await res.json();
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (err) {
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true, state: { error: err.message } });
      }
    };
    finish();
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0A2E2C] text-[#AEE6D5]" data-testid="auth-callback">
      <p className="font-mono text-sm uppercase tracking-[0.22em]">Signing you in…</p>
    </div>
  );
};
